import React from "react";
import { Link, useLocation } from "react-router-dom";
import { SUPPORTED_LANGS } from "@/i18n";

// Preserves the current sub-path (e.g. /pe/privacy -> /en/privacy)
export default function LangSwitcher({ currentLang }) {
  const location = useLocation();

  const buildTo = (lang) => {
    const parts = location.pathname.split("/").filter(Boolean);
    if (SUPPORTED_LANGS.includes(parts[0])) {
      parts[0] = lang;
    } else {
      parts.unshift(lang);
    }
    return "/" + parts.join("/");
  };

  return (
    <div className="kv-lang" data-testid="lang-switcher">
      <Link
        to={buildTo("pe")}
        replace
        aria-label="Español (Perú)"
        data-testid="lang-pe"
      >
        <button className={currentLang === "pe" ? "active" : ""} type="button">
          PE
        </button>
      </Link>
      <Link
        to={buildTo("en")}
        replace
        aria-label="English"
        data-testid="lang-en"
      >
        <button className={currentLang === "en" ? "active" : ""} type="button">
          EN
        </button>
      </Link>
    </div>
  );
}
